import { render, staticRenderFns } from "./myOrderList.vue?vue&type=template&id=bbe084e8&scoped=true&"
import script from "./myOrderList.vue?vue&type=script&lang=js&"
export * from "./myOrderList.vue?vue&type=script&lang=js&"
import style0 from "./myOrderList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./myOrderList.vue?vue&type=style&index=1&id=bbe084e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe084e8",
  null
  
)

export default component.exports